import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import enumCache from '@/shared/services/EnumCacheService';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import AuthService, { features } from '@/shared/services/AuthService';

class ResourceTypeButtonGroup extends PureComponent {
  state = {
    resourceTypes: [],
  };

  componentDidMount() {
    const { intl, allowedTypes } = this.props;
    const hasTrainingFeature = AuthService.hasFeature(features.Training);

    enumCache.get('resourcetype').then(data => {
      this.setState({
        resourceTypes: data
          .filter(item => {
            const isAllowed = !allowedTypes || allowedTypes.indexOf(item.key) >= 0;
            const isTrainingAllowed = hasTrainingFeature || item.key !== 5;
            return isAllowed && isTrainingAllowed;
          })
          .map(item => ({
            id: item.key,
            label: intl.formatMessage(listItemMsg('resourcetype', item.key, item.value)),
          }))
          .sort(dynamicSort('id')),
      });
    });
  }

  toggleRelationType = relType => {
    const { selectedTypes = [], onChange } = this.props;
    const idx = selectedTypes.indexOf(relType);
    if (idx >= 0) {
      onChange(selectedTypes.filter((_, i) => i !== idx));
    } else {
      onChange([...selectedTypes, relType]);
    }
  };

  render() {
    const { resourceTypes } = this.state;
    const { selectedTypes = [] } = this.props;

    return (
      <div role="group" aria-label="relationType" className="btn-group btn-group-justified">
        {resourceTypes &&
          resourceTypes.map(t => (
            <div className="btn-group" key={`ResourceTypeFilter${t.id}`} role="group">
              <button
                onClick={() => {
                  document.activeElement.blur();
                  this.toggleRelationType(t.id);
                }}
                type="button"
                title={t.label}
                className={classnames('btn btn-default', {
                  active: selectedTypes.includes(t.id),
                })}
              >
                {t.label}
              </button>
            </div>
          ))}
      </div>
    );
  }
}

ResourceTypeButtonGroup.propTypes = {
  intl: intlShape.isRequired,
  selectedTypes: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
  allowedTypes: PropTypes.arrayOf(PropTypes.number),
};

ResourceTypeButtonGroup.defaultProps = {
  selectedTypes: [],
  allowedTypes: null,
};

export default injectIntl(ResourceTypeButtonGroup);
